/*
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
*/
import React from 'react';
import DmExecutionSearch from './DmExecutionSearchForm';

const SearchDmExecutionHistory = ({type}) => {
  return (
    <DmExecutionSearch type={type} />
  );
};
export default SearchDmExecutionHistory;
